var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61518 9.73166L9.3517 9.64689L9.15646 9.84308L6.83599 12.1749H5.5509H5.09901V12.6268V13.865H3.8634H3.41151V14.3169V15.5152H0.757799V12.8251L6.45909 7.10176L6.65078 6.90933L6.57079 6.64976C6.43624 6.21313 6.36363 5.74882 6.36363 5.26672C6.36363 2.67687 8.46313 0.577379 11.053 0.577379C13.6428 0.577379 15.7423 2.67687 15.7423 5.26672C15.7423 7.85658 13.6428 9.95607 11.053 9.95607C10.5507 9.95607 10.0677 9.87726 9.61518 9.73166ZM12.4321 5.62193C13.4039 5.62193 14.1916 4.83415 14.1916 3.86237C14.1916 2.89058 13.4039 2.1028 12.4321 2.1028C11.4603 2.1028 10.6725 2.89058 10.6725 3.86237C10.6725 4.83415 11.4603 5.62193 12.4321 5.62193Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.903781,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.fed1417fa4a1793db0d4699458cb4be6.svg";
export { ForwardRef as ReactComponent };